import React from "react";
import Login from "../components/Login";

const LoginScreen = () => {
  return <Login />;
};

export default LoginScreen;
